export const ORDER_STATUS = {
  "Pending Payment": "bg-slate-500/15 text-slate-300 border-slate-500/30",
  "Payment Detected": "bg-blue-500/15 text-blue-300 border-blue-500/30",
  "Payment Confirmed": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Processing": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "In Progress": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "Completed": "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  "Cancelled": "bg-red-500/15 text-red-300 border-red-500/30",
  "Refunded": "bg-purple-500/15 text-purple-300 border-purple-500/30",
};

export function StatusBadge({ status, map = ORDER_STATUS, testid }) {
  const cls = map[status] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
  return <span data-testid={testid} className={`text-xs font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap ${cls}`}>{status}</span>;
}
